if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"src","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(053|187|201|69|763|886)|2([08]63|139|425)|3([13]67|071|085|142|475|716|781|844|870)|4(097|1|234|349|382|702)|5(6(11|42|77)|218|324|509|546|92)|6(1(13|49|7)|2(35|42|7)|3(|67|72)|009|540|592|628|658|769|785|943)|7(14|465|489|592|624|78|930)|8(014|102|505|551|709|730|803|952)|9(0(49|74|9)|35|397|622|684|844))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}